import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ebbffc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "approve_index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "深圳蔓延科技有限公司", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "受益人：深圳市福田区莲花中学", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "订单编号：ADF11233123SDFSDF", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "项目名称：深圳市福田区莲花中学篮球场翻修工程", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "担保金额：100万元", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消订单")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消订单")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("支付保费")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("去签约")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("开发票")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("下载发票")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("下载保函")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_sticky = _resolveComponent("van-sticky")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_sticky, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: _ctx.search.keyword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.keyword) = $event)),
          "show-action": "",
          placeholder: "搜索订单",
          onSearch: _ctx.onSearch
        }, {
          action: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
            }, "搜索")
          ]),
          _: 1
        }, 8, ["modelValue", "onSearch"]),
        _createVNode(_component_van_tabs, {
          active: _ctx.active,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
          color: "#8bc349",
          swipeable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config.status, (value, key, index) => {
              return (_openBlock(), _createBlock(_component_van_tab, {
                key: index,
                title: value
              }, null, 8, ["title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_pull_refresh, {
      class: "list",
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          error: _ctx.error,
          "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.error) = $event)),
          "error-text": "请求失败，点击重新加载",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell_group, {
                class: "cellgroup",
                inset: "",
                key: item,
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.go('/details')), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell, { class: "cell" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_van_tag, {
                        size: "medium",
                        color: item.approval_group == 'group_order'?'#8bc349':(item.approval_group == 'group_change'?'#0982e8':(item.approval_group == 'group_claim'?'#a6937c':(item.approval_group == 'group_refund'?'#f3551e':'#556fb5')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]),
                      _hoisted_2,
                      _createElementVNode("span", {
                        class: _normalizeClass(["status", _ctx.getOrderStatus(item.status)])
                      }, _toDisplayString(_ctx.config.status?_ctx.config.status[item.status]:''), 3)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_cell, { class: "cell" }, {
                    title: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6,
                      (item.status==1)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 0,
                            class: "btn2",
                            plain: "",
                            size: "mini",
                            onClick: _withModifiers(_ctx.quxiao, ["stop"]),
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.status==2  || item.status==3)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 1,
                            class: "btn",
                            plain: "",
                            size: "mini",
                            onClick: _withModifiers(_ctx.quxiao, ["stop"]),
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.status==2)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 2,
                            class: "btn2",
                            plain: "",
                            size: "mini",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.go('/pay')), ["stop"])),
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.status==3)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 3,
                            class: "btn2",
                            plain: "",
                            size: "mini",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.go('/xieyi')), ["stop"])),
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.status==4)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 4,
                            class: "btn2",
                            plain: "",
                            size: "mini",
                            onClick: _withModifiers(_ctx.fapiao, ["stop"]),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.status==5)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 5,
                            class: "btn",
                            plain: "",
                            size: "mini",
                            onClick: _withModifiers(_ctx.downpiao, ["stop"]),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.status==5)
                        ? (_openBlock(), _createBlock(_component_van_button, {
                            key: 6,
                            class: "btn2",
                            plain: "",
                            size: "mini",
                            onClick: _withModifiers(_ctx.downbh, ["stop"]),
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "error", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}